import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=f128808a&scoped=true&"
import script from "./footBar.vue?vue&type=script&lang=js&"
export * from "./footBar.vue?vue&type=script&lang=js&"
import style0 from "./footBar.vue?vue&type=style&index=0&id=f128808a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f128808a",
  null
  
)

export default component.exports